import { Component, Input } from '@angular/core';
import { UiBreadcrumbItem } from '../../models/ui-sidebar.model';

@Component({
  selector: 'app-ui-breadcrumb',
  templateUrl: './ui-breadcrumb.component.html',
  styleUrls: ['./ui-breadcrumb.component.scss']
})
export class UiBreadcrumbComponent {
  @Input() items: UiBreadcrumbItem[] = [];
}
